import { gsap } from "gsap";

const DISPLAY_DURATION = 4;
const TRANSITION_DURATION = 1;
const SCROLL_SPEED = 50; // px / 秒
const SCROLL_START_DELAY = 1;
const SCROLL_END_DELAY = 1.5;

export default class NewsTicker {
    constructor() {
        this.newsWrap = document.querySelector(".js-news-ticker");
        this.newsList = this.newsWrap?.querySelector(".js-news-list");
        if (!this.newsList) return;

        this.newsItems = Array.from(this.newsList.children).slice(0, 3);
        if (!this.newsItems.length) return;

        this.currentIndex = 0;
        this.animation = null;
        this.viewportWidth = 0;

        this.newsItems.forEach((item) => this.setItemActive(item, false));
        this.newsWrap.addEventListener("focusin", () => this.animation?.pause());
        this.newsWrap.addEventListener("focusout", (event) => {
            if (!this.newsWrap.contains(event.relatedTarget)) this.animation?.resume();
        });

        // 表示幅が変わったら、現在の記事で移動距離を計算し直す。
        this.resizeObserver = new ResizeObserver(() => {
            if (this.newsList.clientWidth !== this.viewportWidth) this.showCurrent();
        });
        this.resizeObserver.observe(this.newsList);
        this.showCurrent();
    }

    setItemActive(item, active) {
        gsap.set(item, { autoAlpha: active ? 1 : 0 });
        item.setAttribute("aria-hidden", String(!active));
        item.querySelector("a")?.setAttribute("tabindex", active ? "0" : "-1");
    }

    showCurrent() {
        this.animation?.kill();
        this.viewportWidth = this.newsList.clientWidth;
        if (!this.viewportWidth) return;

        const item = this.newsItems[this.currentIndex];
        const itemWidth = item.getBoundingClientRect().width;
        const overflow = Math.max(0, itemWidth - this.viewportWidth);

        gsap.set(item, { x: this.viewportWidth, xPercent: 0, y: 0, yPercent: 0 });
        this.setItemActive(item, true);

        this.animation = gsap.timeline({
            onComplete: () => {
                this.setItemActive(item, false);
                this.currentIndex = (this.currentIndex + 1) % this.newsItems.length;
                this.showCurrent();
            },
        });

        // 右から入って一旦停止し、長い記事だけ末尾までゆっくり流す。
        this.animation.to(item, { x: 0, duration: TRANSITION_DURATION, ease: "sine.inOut" });
        if (overflow > 0) {
            this.animation.to(item, {
                x: -overflow,
                duration: overflow / SCROLL_SPEED,
                delay: SCROLL_START_DELAY,
                ease: "none",
            });
        }
        this.animation.to(item, {
            x: -itemWidth,
            duration: TRANSITION_DURATION,
            delay: overflow > 0 ? SCROLL_END_DELAY : DISPLAY_DURATION,
            ease: "sine.inOut",
        });

        if (this.newsWrap.matches(":focus-within")) this.animation.pause();
    }
}
